import { useConfigStore } from '@/store/config.store';
import type { CuttingShape } from '@/domain/cuttingShape/CuttingShape';
import type { ICuttingShapeRepository } from '@/application/ports/ICuttingShapeRepository';

class PiniaCuttingShapeRepository implements ICuttingShapeRepository {
    get(): CuttingShape | undefined {
        return useConfigStore().cuttingShape;
    }

    set(shape: CuttingShape | undefined): void {
        useConfigStore().cuttingShape = shape;
    }
}

export { PiniaCuttingShapeRepository };
